
<main>
  <section>
    <div *ngIf="infoLoaded == 0" class="row justify-content-center page-loading ptb-240"></div>
    <div *ngIf="infoLoaded == 1 && !hasError" class="container custom-container-detail ptb-120 px-5 px-lg-0">
      <div class="card p-3 bdr-r-10">
        <div class="card-header bg-white">
          <div class="flex-sm-row flex-column-reverse justify-content-between">
            <div class="col my-auto">
              <p *ngIf=" complaint.status == 'PENDING' " class="fw-700 m-0">{{'complaintDetail.title' | translate}}</p>
              <p *ngIf=" complaint.status == 'PENDING' ">{{'complaintDetail.subtitle' | translate}}</p>
              <h6 class="col-12 fw-900">{{'complaintDetail.' + complaint.type | translate}} <span class="color-primary">{{complaint.identifier}}</span></h6>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row justify-content-between mt-4">
            <div class="col-12"><h6 class="fw-900 fs-18px">{{'complaintDetail.personalInformation' | translate}}</h6></div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'complaintDetail.name' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{complaint.name}}</p></div>
              </div>
              <div class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'complaintDetail.email' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{complaint.email}}</p></div>
              </div>
              <div class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'complaintDetail.contact' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{complaint.phone}}</p></div>
              </div>
            </div>
          </div>
          <div class="row justify-content-between mt-4">
            <div class="col-12"><h6 class="fw-900 fs-18px">{{'complaintDetail.information' | translate}}</h6></div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <div class="row justify-content-between mb-4">
                <div class="col-auto"><p class="mb-1 fw-800">{{'complaintDetail.openedAt' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{complaint.createdAt | date:'dd-MM-yyyy HH:mm:ss'}}</p></div>
              </div>
              <div *ngIf="complaint.municipality != ''" class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'complaintDetail.municipality' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{complaint.municipality}}</p></div>
              </div>
              <div *ngIf="complaint.line != ''" class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'complaintDetail.line' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{complaint.line}}</p></div>
              </div>
              <div *ngIf="complaint.operator && complaint.operator != 'CIMTS'" class="row justify-content-between d-flex align-items-center">
                <div class="col-auto"><p class="mb-1 fw-700">{{'complaintDetail.operator' | translate}}:</p></div>
                <div class="col-auto mb-3 d-flex align-items-center">
                  <ng-container *ngFor="let logo of lineOperatorLogos; let i = index" >
                      <img
                        [src]="'assets/img/logos/operators/' + logo + '.png'"
                        [alt]="logo"
                        class="p-3 logo-footer"/>
                      <span *ngIf="i < lineOperatorLogos.length -1">/</span>
                    </ng-container>
                </div>
              </div>
              <div *ngIf="complaint.stop != ''" class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'complaintDetail.stop' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{complaint.stop}}</p></div>
              </div>
              <div *ngIf="complaint.place != ''" class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'complaintDetail.place' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{complaint.place}}</p></div>
              </div>
              <div *ngIf="complaint.occurrence_date" class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'complaintDetail.date' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{complaint.occurrence_date | date:'dd-MM-yyyy'}}</p></div>
              </div>
              <div *ngIf="complaint.time != ''" class="row justify-content-between">
                <div class="col-auto"><p class="mb-1 fw-700">{{'complaintDetail.hour' | translate}}:</p></div>
                <div class="text-end col"><p class="mb-1">{{complaint.time}}</p></div>
              </div>
              <div *ngIf="complaint.subsubject != undefined && complaint.subsubject != ''" class="row justify-content-between mt-4">
                <div class="col-12"><p class="m-0 fw-700">{{'complaintDetail.subsubject' | translate}}:</p></div>
                <div class="col-12"><p>{{complaint.subsubject}}</p></div>
              </div>
              <div class="row justify-content-between mt-4">
                <div class="col-12"><p class="m-0 fw-700">{{'complaintDetail.message' | translate}}:</p></div>
                <div class="col-12"><p class="notes-content">{{complaint.message}}</p></div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="statusComplain">
            <div class="row justify-content-between align-items-center my-3">
              <div class="col-auto"><h6 class="m-0 fs-20px fw-900">{{'complaintDetail.status' | translate}}:</h6></div>
              <div *ngIf=" complaint.status != 'PENDING' " class="col-auto"><span class="badge rounded-pill text-bg-success">{{'complaintDetail.CLOSE' | translate}}</span></div>
              <div *ngIf=" complaint.status == 'PENDING' " class="col-auto"><span class="badge rounded-pill text-bg-warning">{{'complaintDetail.OPEN' | translate}}</span></div>
            </div>
            <ng-container *ngIf=" complaint.status != 'PENDING' ">
              <div class="row justify-content-between my-3">
                <div class="col-auto"><p class="m-0 fw-700">{{'complaintDetail.closedAt' | translate}}:</p></div>
                <div class="text-end col"><p class="m-0">{{complaint.closedAt | date:'dd-MM-yyyy HH:mm:ss'}}</p></div>
              </div>
              <div class="row justify-content-between">
                <div class="col-12"><p class="m-0 fw-700">{{'complaintDetail.notes' | translate}}:</p></div>
                <div class="col-12"><p class="notes-content">{{complaint.notes}}</p></div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- ======= Submit Button ======= -->
      <div class="row justify-content-between">
        <div class="col-auto my-3">
          <button title="Botão Contactos" class="btn-custom btn-3" [routerLink]="'/contactos'"><span><p class="my-auto fw-600">{{'navLinks.contactos' | translate}}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span></button>
        </div>
        <div class="col-auto my-3">
          <button title="Botão ir para Início" class="btn-custom btn-3" (click)="goHome()"><span><p class="my-auto fw-600">{{'buttons.goToHome' | translate}}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span></button>
        </div>
      </div>
      <!-- =======End Submit Button ======= -->
    </div>
    <div *ngIf="hasError" class="container custom-container-detail ptb-120 px-4 px-lg-0">
      <div class="row justify-content-center">
        <div class="alert alert-warning bdr-r-10">
          <p class="m-0">{{'complaintDetail.errorTitle' | translate}}</p>
          <p class="m-0">{{'complaintDetail.errorSubtitle1' | translate}}</p>
          <p class="m-0 fw-800">{{'complaintDetail.errorSubtitle2' | translate}}</p>
        </div>
      </div>
      <div class="row justify-content-between">
        <div class="col-auto my-3 p-0">
          <button title="Botão Contactos" class="btn-custom btn-3" [routerLink]="'/contactos'"><span><p class="my-auto fw-600">{{'navLinks.contactos' | translate}}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span></button>
        </div>
        <div class="col-auto my-3 p-0">
          <button title="Botão ir para Início" class="btn-custom btn-3" (click)="goHome()"><span><p class="my-auto fw-600">{{'buttons.goToHome' | translate}}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span></button>
        </div>
      </div>
    </div>
  </section>
</main>

